<div class="Content-reg wrapper">
  <header class="header-top" header-theme="light" style="font-weight: 500">
    <div class="container-fluid">
      <div class="d-flex justify-content-between">
        <div class="top-menu d-flex align-items-center">
          <button type="button" class="btn-icon mobile-nav-toggle d-lg-none">
            <span></span>
          </button>

          <!--  <div class="dropdown">
                <a class="dropdown-toggle" href="#" id="userRolesDropdown" role="button" data-toggle="dropdown">
                    <i class="ik ik-chevron-down"></i> <span style="font-size: 14px">{{selectedRole}}</span>  </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userRolesDropdown">
                    <ng-container *ngFor="let role of roles" >
                            <a class="dropdown-item" href="#" (click)="ChosseRole(role)"> {{role}}</a>
                    </ng-container>

                  </div>
            </div> -->

          <!--   <div class="dropdown">
                  <a class="dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown">
                      <i class="ik ik-chevron-down"></i>
                    <img class="avatar" src="assets/images/avatar.png" alt=""> <span style="font-size: 14px">  {{global.FirstName }} {{global.LastName}}     </span>  </a>
                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown"> -->
          <!-- <a class="dropdown-item" href="profile.html"><i class="ik ik-user dropdown-icon"></i> Profile</a>
                      <a class="dropdown-item" href="#"><i class="ik ik-settings dropdown-icon"></i> Settings</a>
                      <a class="dropdown-item" href="#"><span class="float-right"><span class="badge badge-primary">6</span></span><i class="ik ik-mail dropdown-icon"></i> Inbox</a>
                      <a class="dropdown-item" href="#"><i class="ik ik-navigation dropdown-icon"></i> Message</a> -->
          <!--     <a class="dropdown-item" routerLink="" (click)="logOut()"><i class="ik ik-power dropdown-icon"></i>{{'ToolBar.Logout'|translate}}</a>
                    </div>
              </div> -->

          <!-- <a class="header-brand" [routerLink]="['/']">
                <div class="logo-img">
                   <img src="assets/images/logoex5.png" class="header-brand-img" alt="SEU">
                </div>

            </a> -->
        </div>

        <div class="top-menu d-flex align-items-center">
          <!--  <div class="d-none d-sm-block">
            <div class="input-group">


              <div class="dropdown search">
                <a class="dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown">
                  <span style="font-size: 14px">  Choose Clinic    </span>
                  <i class="ik ik-chevron-down"></i> </a>
                <div class="dropdown-menu dropdown-menu-right se" aria-labelledby="userDropdown">
                    <a class="dropdown-item" href=""><i class="ik ik-heart dropdown-icon"></i> Dentist</a>
                    <a class="dropdown-item" href=""><i class="ik ik-heart dropdown-icon"></i> Pediatrics</a>

                  </div>
            </div>

              <input type="text" class="form-control" placeholder="Search By Doctor Name">

              <div class="input-group-append">
                <button class="btn btn-search" type="button"><i class="ik ik-search"></i></button>
              </div>

            </div>
          </div> -->
        </div>

        <div class="top-menu d-flex align-items-center">
          <!-- <button type="button" class="btn-icon mobile-nav-toggle d-lg-none"><span></span></button> -->
          <!--   <div class="header-search">
                <div class="input-group">
                    <span class="input-group-addon search-close"><i class="ik ik-x"></i></span>
                    <input type="text" class="form-control">
                    <span class="input-group-addon search-btn"><i class="ik ik-search"></i></span>
                </div>
            </div> -->

          <!-- Dependatnt Or Dependent List-->

          <!--  <div class="dropdown" *ngIf="isEmpolyee">-->
          <!--  <div class="dropdown" *ngIf="this.global.Role == 'EmployeePatient'">

                <a class="dropdown-toggle" href="javascript:void(0);" id="employeeDependants" role="button" data-toggle="dropdown">
                    <i class="ik ik-chevron-down"></i> <span style="font-size: 14px">{{selectedDependant}}</span>  </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userRolesDropdown">
                    <a class="dropdown-item" href="javascript:void(0);"  (click)="ChooseDependant(loginUserId,loginUserName,loginPatientId)"> {{loginUserName}}</a>
                    <ng-container *ngFor="let dep of empDependants" >
                            <a class="dropdown-item" href="javascript:void(0);"  (click)="ChooseDependant(dep.dependentUserId,dep.userName,dep.patientId)"> {{dep.userName}}</a>
                    </ng-container>

                  </div>
            </div> -->

          <!-- User Role List-->
          <!-- <div class="dropdown">
              <a class="dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown">
                <i class="ik ik-chevron-down"></i> -->
          <!-- <img class="avatar" src="assets/images/avatar.png" alt="">  -->
          <!--                 <span style="font-size: 14px"> {{global.CurrentLang == 'AR' ? selectedRoleDetails.arRoleName : selectedRoleDetails.enRoleName}} </span>
 -->
          <!-- <span style="font-size: 14px">  {{selectedRole}}     </span> -->
          <!--   </a>
              <div class="dropdown-menu  user-drop" aria-labelledby="userDropdown">
                <a class="dropdown-item" href="javascript:void(0);" *ngFor="let role of userRolesDetails ;let i=index;"
                  (click)="ChangeUserRole(role)"><i class="ik ik-user dropdown-icon"></i>
                  {{global.CurrentLang == 'AR' ? role.arRoleName : role.enRoleName}}</a>
              </div>

            </div> -->

          <!--  <div class="dropdown">
              <a class="dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown">
                  <i class="ik ik-chevron-down"></i>

                <span style="font-size: 14px">  {{global.FirstName }} {{global.LastName}}     </span>  </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
                  <a class="dropdown-item" href="#"><i class="ik ik-user dropdown-icon"></i> de user</a>
                  <a class="dropdown-item" href="#"><i class="ik ik-user dropdown-icon"></i> de user</a>

                  <a class="dropdown-item" routerLink="" (click)="logOut()"><i class="ik ik-power dropdown-icon"></i>{{'ToolBar.Logout'|translate}}</a>
                </div>
          </div>
        -->
          <div class="header-date d-none d-lg-block" style="direction: rtl">
            <!-- <span class="media" style="font-size: 14px;">

                  <span>
                    <span *ngIf="translate.currentLang == 'en'" style="color: #fff;">m</span>


                     {{ getDate()  }}

                  </span>



                  &nbsp; &nbsp;  - &nbsp; &nbsp;
                  <span class="" id="date">
                  </span>
                </span> -->
          </div>

          <!--
            <div class="dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="notiDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="UpdateNotificationsToReaded()"><i class="ik ik-bell"></i><span class="badge bg-danger">{{ getNotReadCount() }}</span></a>
                <div class="dropdown-menu dropdown-menu-right notification-dropdown" aria-labelledby="notiDropdown" >
                    <h4 class="header">{{'ToolBar.Notifications'|translate}}</h4>


                      <span *ngFor="let item of global.Notifications">
                    <div class="notifications-wrap"  >

                        <span class="media">
                            <span class="d-flex">
                                <i class="ik ik-check"></i>
                            </span>
                            <span class="media-body" >
                                <a href='{{item.action}}' class="heading-font-family media-heading">{{item.message}}</a>

                            </span>
                        </span>

                    </div>
                  </span>
                    <div class="footer"><a  [routerLink]="['/notification/']" >{{'ToolBar.SeeAll'|translate}} </a></div>
                </div>
            </div> -->

          <div id="drop2" class="dropdown">
            <a
              class="dropdown-toggle"
              href="#"
              id="userDropdown"
              role="button"
              data-toggle="dropdown"
              style="line-height: 1.9"
            >
              <!-- <i class="ik ik-chevron-down" style="color:#000"></i> -->
              <img
                src="assets/images/icons/header-arrow-down.svg"
                alt="arrow down icon"
              />
              <!-- <img class="avatar" src="assets/images/saudi-avatar.jpg" alt="">  -->
              <img
                src="assets/images/icons/avatar.svg"
                class="avatar"
                alt="avatar"
              />
              <span style="font-size: 14px"> </span>
              <span style="font-size: 14px; color: #000">اسم المستخدم </span>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="userDropdown"
            >
              <!-- <a class="dropdown-item" href="profile.html"><i class="ik ik-user dropdown-icon"></i> Profile</a>
                  <a class="dropdown-item" href="#"><i class="ik ik-settings dropdown-icon"></i> Settings</a>
                  <a class="dropdown-item" href="#"><span class="float-right"><span class="badge badge-primary">6</span></span><i class="ik ik-mail dropdown-icon"></i> Inbox</a>
                  <a class="dropdown-item" href="#"><i class="ik ik-navigation dropdown-icon"></i> Message</a> -->
              <a class="dropdown-item" routerLink="" style="color: #000">
                <!-- <i class="ik ik-power dropdown-icon"></i> -->
                <img
                  src="assets/images/icons/log-out-icon.svg"
                  alt="log out icon"
                />
                تسجيل خروج</a
              >
            </div>
          </div>
          <!-- <div class="lang" >
              <a class="" routerLink="" (click)="logOut()"><i class="ik ik-power dropdown-icon" style="font-size: 20px; font-weight: 400"></i></a>
            </div>  -->
          <!-- <button type="button" id="navbar-fullscreen" class="nav-link"><i class="ik ik-maximize"></i></button> -->
          <div class="lang">
            <a
              href="javascript:void(0)"
              *ngIf="global.CurrentLang == 'en'"
              class="social"
              style="margin: 0 10px"
              (click)="langAR('AR')"
            >
              <!-- <img src="assets/images/ar.png" width="25px" /> -->
              <img src="assets/images/icons/lang.svg" width="25px" />
              عربي
            </a>
            <a
              href="javascript:void(0)"
              *ngIf="global.CurrentLang == 'AR'"
              class="social"
              style="margin: 0 10px"
              (click)="langEn('en')"
            >
              <!-- <img src="assets/images/en.png" width="25px" /> -->
              <img src="assets/images/icons/lang.svg" width="25px" />
              English
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
  <div class="page-wrap">
    <div class="main-content">
      <div class="container">
        <div class="widget">
          <div class="card">
            <div class="header">
              <div class="d-flex justify-content-between align-items-center">
                <h3 class="widget-title">
                  <i class="fas fa-chalkboard-teacher"></i>
                  <span>تسجيل </span>مستخدم جديد
                </h3>
              </div>
            </div>
            <div class="card-body" style="padding: 15px 15px">
              <div class="loading-indicator" *ngIf="global.spinner">
                <mat-progress-spinner
                  mode="indeterminate"
                ></mat-progress-spinner>
              </div>
              <form [formGroup]="patientForm" (ngSubmit)="addPatient()">
                <div class="row">
                  <!-- الاسم الأول -->
                  <div class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>الاسم الأول باللغة العربية</mat-label>
                      <input
                        matInput
                        formControlName="firstName"
                        [(ngModel)]="patient.firstName"
                        required
                      />
                      <!-- <mat-error *ngIf="patientForm.controls.firstName.errors.required">inalid first name</mat-error> -->
                      <mat-error *ngIf="patientForm.controls.firstName.errors">
                        <span
                          *ngIf="patientForm.controls.firstName.errors.pattern"
                          >يجب ادخال حروف عربية فقط</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- اسم الأب -->
                  <div class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>اسم الأب باللغة العربية</mat-label>
                      <input
                        matInput
                        formControlName="middleName"
                        [(ngModel)]="patient.middleName"
                        required
                      />
                      <mat-error *ngIf="patientForm.controls.middleName.errors">
                        <span
                          *ngIf="patientForm.controls.middleName.errors.pattern"
                          >يجب ادخال حروف عربية فقط</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- اسم العائلة -->
                  <div class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>اسم العائلة باللغة العربية</mat-label>
                      <input
                        matInput
                        formControlName="lastName"
                        [(ngModel)]="patient.lastName"
                        required
                      />
                      <mat-error *ngIf="patientForm.controls.lastName.errors">
                        <span
                          *ngIf="patientForm.controls.lastName.errors.pattern"
                          >يجب ادخال حروف عربية فقط</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- en الاسم الأول-->
                  <div class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label> الاسم الأول باللغة الانجليزية</mat-label>
                      <input
                        matInput
                        formControlName="firstNameEn"
                        [(ngModel)]="patient.firstNameEn"
                        required
                      />
                      <!-- <mat-error *ngIf="patientForm.controls.firstName.errors.required">inalid first name</mat-error> -->
                      <mat-error
                        *ngIf="patientForm.controls.firstNameEn.errors"
                      >
                        <span
                          *ngIf="
                            patientForm.controls.firstNameEn.errors.pattern
                          "
                          >يجب ادخال حروف انجليزية فقط</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- en اسم الأب -->
                  <div class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>اسم الأب باللغة الانجليزية</mat-label>
                      <input
                        matInput
                        formControlName="middleNameEn"
                        [(ngModel)]="patient.middleNameEn"
                        required
                      />
                      <mat-error
                        *ngIf="patientForm.controls.middleNameEn.errors"
                      >
                        <span
                          *ngIf="
                            patientForm.controls.middleNameEn.errors.pattern
                          "
                          >يجب ادخال حروف انجليزية فقط</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- en اسم العائلة -->
                  <div class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>اسم العائلة باللغة الانجليزية</mat-label>
                      <input
                        matInput
                        formControlName="lastNameEn"
                        [(ngModel)]="patient.lastNameEn"
                        required
                      />
                      <mat-error *ngIf="patientForm.controls.lastNameEn.errors">
                        <span
                          *ngIf="patientForm.controls.lastNameEn.errors.pattern"
                          >يجب ادخال حروف انجليزية فقط</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- البريد الالكتروني -->
                  <div class="col-md-6 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>البريد الالكتروني</mat-label>
                      <input
                        matInput
                        formControlName="email"
                        [(ngModel)]="patient.email"
                        (blur)="EmailExist()"
                        required
                      />
                      <mat-error *ngIf="patientForm.controls.email.errors">
                        <!-- <span *ngIf="patientForm.controls.email.errors.required">يجب ادخال البريد الالكترونى</span> -->
                        <span *ngIf="patientForm.controls.email.errors.pattern"
                          >البريد الإلكترونى يجب أن يكون بصيغة :
                          email@email.com</span
                        >
                        <span
                          *ngIf="patientForm.controls.email.errors.notUnique"
                        >
                          هذا البريد الالكترونى موجود بالفعل.</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- تاريخ الميلاد -->
                  <div class="col-md-3 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>تاريخ الميلاد</mat-label>
                      <input
                        matInput
                        [matDatepicker]="picker"
                        formControlName="birthDate"
                        [(ngModel)]="patient.birthDate"
                        required
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>

                  <!-- الجنس -->
                  <div class="col-md-3 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>الجنس</mat-label>
                      <mat-select
                        name="gender"
                        formControlName="gender"
                        [(ngModel)]="patient.gender"
                        required
                      >
                        <mat-option value="Male">ذكر</mat-option>
                        <mat-option value="Female">أنثى</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- الدولة -->
                  <div class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>الدولة</mat-label>
                      <mat-select
                        formControlName="country"
                        [(ngModel)]="patient.country"
                        (selectionChange)="selectCountry($event)"
                        required
                      >
                        <mat-option>
                          <ngx-mat-select-search
                            [formControl]="nationalityFilterCtrl"
                          ></ngx-mat-select-search>
                        </mat-option>
                        <mat-option
                          [value]="item.nameArabic"
                          *ngFor="let item of filteredNationalities | async"
                          >{{ item.nameArabic }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- المدينة -->
                  <div class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>المدينة</mat-label>
                      <input
                        matInput
                        name="city"
                        formControlName="city"
                        [(ngModel)]="patient.city"
                        required
                      />
                    </mat-form-field>
                  </div>

                  <!-- الحى -->
                  <div class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>الحى</mat-label>
                      <input
                        matInput
                        name="neighborhood"
                        formControlName="neighborhood"
                        [(ngModel)]="patient.neighborhood"
                      />
                    </mat-form-field>
                  </div>

                  <!-- <div class="col-md-4 col-sm-6 col-12">
              <mat-form-field appearance="fill">
                <mat-label>العنوان</mat-label>
                <input matInput name="address" formControlName="address" [(ngModel)]="patient.address">
                <mat-error *ngIf="patientForm.controls.address.errors">
                  <span *ngIf="patientForm.controls.address.errors.pattern">يجب أن يكون العنوان بهذا الشكل : الدولة - المدينة - الحى </span>
                </mat-error>
              </mat-form-field>
            </div> -->

                  <!-- جهه العمل -->
                  <div class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>جهة العمل</mat-label>
                      <input
                        matInput
                        formControlName="workPlace"
                        [(ngModel)]="patient.workPlace"
                      />
                    </mat-form-field>
                  </div>

                  <!-- الجنسية -->
                  <div class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>الجنسية</mat-label>
                      <mat-select
                        formControlName="nationality"
                        [(ngModel)]="patient.nationality"
                        required
                      >
                        <mat-option>
                          <ngx-mat-select-search
                            [formControl]="countryFilterCtrl"
                          ></ngx-mat-select-search>
                        </mat-option>
                        <mat-option
                          [value]="item.nameArabic"
                          *ngFor="let item of filteredCountries | async"
                          >{{ item.nameArabic }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- النوع -->
                  <div class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>النوع</mat-label>
                      <mat-select
                        formControlName="type"
                        [(ngModel)]="patient.type"
                        required
                      >
                        <mat-option value="R">قارئ</mat-option>
                        <mat-option value="N">غير قارئ</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- رمز الهاتف  -->
                  <div class="col-md-1 col-sm-1 col-2">
                    <mat-form-field appearance="fill">
                      <mat-label>رمز الهاتف </mat-label>
                      <input
                        matInput
                        [value]="patient.countryPhoneCode"
                        disabled
                      />
                    </mat-form-field>
                  </div>

                  <!-- رقم الجوال -->
                  <div class="col-md-3 col-sm-5 col-10">
                    <mat-form-field appearance="fill">
                      <mat-label>رقم الجوال</mat-label>
                      <input
                        matInput
                        formControlName="phoneNumber"
                        [(ngModel)]="patient.phoneNumber"
                        (blur)="PhoneNumberExist()"
                        required
                      />
                      <mat-error
                        *ngIf="patientForm.controls.phoneNumber.errors"
                      >
                        <span
                          *ngIf="
                            patientForm.controls.phoneNumber.errors.pattern
                          "
                          >يجب ان لا يقل رقم الجوال عن 10 أرقام</span
                        >
                        <span
                          *ngIf="
                            patientForm.controls.phoneNumber.errors.maxlength
                          "
                          >رقم الجوال يجب أن لا يزيد عن 11 رقم</span
                        >
                        <span
                          *ngIf="
                            patientForm.controls.phoneNumber.errors.notUnique
                          "
                          >عفوا , لقد تم التسجيل بهذا الجوال من قبل.</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- رقم الهوية -->
                  <div class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>رقم الهوية</mat-label>
                      <input
                        matInput
                        formControlName="idCardNumber"
                        [(ngModel)]="patient.idCardNumber"
                        (blur)="IdCardNumberExist()"
                      />
                      <mat-error
                        *ngIf="patientForm.controls.idCardNumber.errors"
                      >
                        <span
                          *ngIf="
                            patientForm.controls.idCardNumber.errors.pattern
                          "
                          >الهوية يجب أن تبدأ برقم 1 أو 2 وأن لا تقل عن 10
                          أرقام</span
                        >
                        <span
                          *ngIf="
                            patientForm.controls.idCardNumber.errors.maxlength
                          "
                          >الهوية يجب أن لا تزيد عن 16 رقم</span
                        >
                        <span
                          *ngIf="
                            patientForm.controls.idCardNumber.errors.notUnique
                          "
                          >عفوا , لقد تم التسجيل بهذه الهوية من قبل.</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-md-4 col-sm-6 col-12"></div>

                  <!-- كلمة السر -->
                  <div *ngIf="!userId" class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>كلمة السر</mat-label>
                      <input
                        matInput
                        [type]="hidePassword ? 'password' : 'text'"
                        formControlName="password"
                        [(ngModel)]="patient.password"
                        required
                      />
                      <span
                        mat-icon-button
                        matSuffix
                        (click)="hidePassword = !hidePassword"
                        [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="hidePassword"
                        style="cursor: pointer"
                      >
                        <mat-icon>{{
                          hidePassword ? "visibility_off" : "visibility"
                        }}</mat-icon>
                      </span>
                      <mat-error
                        *ngIf="
                          submitted &&
                          patientForm.controls.password.value &&
                          patientForm.controls.password.errors
                        "
                      >
                        <!-- <span *ngIf="patientForm.controls.password.value.length < 6">يجب .</span> -->
                        <span
                          *ngIf="patientForm.controls.password.errors.pattern"
                          >كلمة المرور يجب أن لا تقل عن 6 احرف وأن تحتوى على حرف
                          كبير وحرف صغير وأرقام.</span
                        >
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- تأكيد كلمة السر -->
                  <div *ngIf="!userId" class="col-md-4 col-sm-6 col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>تأكيد كلمة السر</mat-label>
                      <input
                        matInput
                        type="password"
                        formControlName="confirmPassword"
                        required
                      />
                      <mat-error
                        *ngIf="
                          submitted &&
                          patientForm.controls.confirmPassword.value != '' &&
                          patientForm.controls.password.value !=
                            patientForm.controls.confirmPassword.value
                        "
                      >
                        كلمةالسر غير متطابقة
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div
                    *ngIf="!userId"
                    class="col-md-6 col-sm-6 col-12 flex mt-3"
                  >
                    <label class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        value="option1"
                        formControlName="acceptTerms"
                        [ngClass]="{
                          'is-invalid':
                            submitted && patientForm.controls.acceptTerms.errors
                        }"
                        required
                      />
                      <span class="custom-control-label" style="color: grey"
                        >&nbsp;أوافق علي الشروط والأحكام</span
                      >
                      <span
                        *ngIf="
                          submitted && patientForm.controls.acceptTerms.errors
                        "
                        class="invalid-feedback"
                        >يجب الموافقه علي الشروط والأحكام</span
                      >
                    </label>

                    <a
                      (click)="openTermsAndConditions()"
                      class="mx-4"
                      style="color: #00839b; cursor: pointer"
                      >( اضغط هنا للاطلاع )</a
                    >
                  </div>

                  <br />

                  <button
                    id="btnAdd"
                    style="
                      width: 25%;
                      height: 40px;
                      background-color: #00839b;
                      color: #fff;
                      border: none;
                      margin-top: 50px;
                      margin: auto;
                      display: table;
                      margin-bottom: 20px;
                    "
                    type="submit"
                    class="btn btn-primary mt-3"
                  >
                    تسجيل حساب جديد
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer
      class="footer"
      style="text-align: center; font-weight: 500; font-size: 14px"
    >
      <div class="w-100 clearfix">
        <span class="text-center"
          >جميع الحقوق محفوظة لمركز حلول التواصل الطبية
        </span>
        <!-- <span class="float-none float-sm-right mt-1 mt-sm-0 ">Made by <a href="#" class="text-dark" target="_blank">Cptit</a></span> -->
      </div>
    </footer>
  </div>
</div>

<!-- <div class="container-fluid">

    <div class="page-header">
        ghghghggh
        <div class="row align-items-end">
            <div class="col-lg-8">
                <div class="page-header-title">
                    <i class="ik ik-book-open"></i>
                    <div class="d-inline">
                        <h5>{{'Admin.AdduserD.Adduser' | translate}}</h5>
                        <span></span>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <nav class="breadcrumb-container" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a href="/"><i class="ik ik-home"></i></a>
                        </li>
                        <li class="breadcrumb-item">
                            <a href="/admin/user"> {{'Admin.AdduserD.Adduser' | translate}}</a>
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
<div class="row">
    <div class="col-8">
<mat-form-field>
    <input  matInput [formControl]="firstName" [(ngModel)]="formData.firstName"   id="first-name" placeholder=" {{'Admin.AdduserD.FirstName' | translate}}" name="firstName" tmFocus >
    <mat-hint> {{'Admin.AdduserD.EnterFirstName' | translate}}</mat-hint>
    <mat-error *ngIf="firstName.invalid">{{getFirstnameErrorMessage()}}</mat-error>
</mat-form-field><br>
<mat-form-field>
    <input  matInput [formControl]="lastName" [(ngModel)]="formData.lastName"   id="last-name" placeholder=" {{'Admin.AdduserD.LastName' | translate}}" name="lastName" >
    <mat-hint> {{'Admin.AdduserD.EnterlastName' | translate}}</mat-hint>
    <mat-error *ngIf="lastName.invalid">{{getLastnameErrorMessage()}}</mat-error>
  </mat-form-field><br>
<mat-form-field>
    <input id="userName" #user matInput  [formControl]="userName" (focusout)='focusout(user)' [(ngModel)]="formData.userName" required name="userName"    placeholder=" {{'Admin.AdduserD.UserName' | translate}}"   >
    <mat-hint> {{'Admin.AdduserD.EnterUserName' | translate}}</mat-hint>
    <mat-error *ngIf="userName.invalid">{{getEmailErrorMessage()}}</mat-error>
  </mat-form-field><br>
  <p *ngIf ='focusOut !=null' style="color: red;font-size: small;">   {{'Admin.AdduserD.UserAlreadyExist' | translate}}</p>
  <mat-form-field *ngIf ='focusOut !=null' style="color: red;">
    <mat-label>This user is found enter new user</mat-label>
  </mat-form-field>
<mat-form-field>
    <input id="email"  matInput [formControl]="email" [(ngModel)]="formData.email" required name="email"     placeholder="Email" >
    <mat-hint>Enter User Name Like : Example@seu.edu.sa</mat-hint>
    <mat-error *ngIf="email.invalid">{{getEmailErrorMessage()}}</mat-error>
  </mat-form-field><br>
  <mat-form-field>
  <input  type="password" matInput  [formControl]="password" [(ngModel)]="formData.password"     id="password" name="password" placeholder=" {{'Admin.AdduserD.Password' | translate}}"  minlength="6">
  <mat-hint>{{'Admin.AdduserD.Enterpassword' | translate}}</mat-hint>
  <mat-error *ngIf="password.invalid">{{getPasswordErrorMessage()}}</mat-error>
  </mat-form-field><br><br>
</div>
<div class="col-4">
  <ng-container>

    <p> {{'Admin.AdduserD.Active' | translate}}</p>
        <div class="block">

        <input type="radio" name="active" [checked]="formData.active"  (change)="SetActive(true)"  value="true" />
                <label  > {{'Admin.AdduserD.True' | translate}}</label>
        </div>
        <div class="block">

                <input type="radio" name="active" [checked]="!formData.active"  (change)="SetActive(false)" value="false" />
                <label  > {{'Admin.AdduserD.False' | translate}}</label>
        </div>

  </ng-container>

    <br>

<ng-container *ngFor="let role of roles">
        <div class="block">
<input    [name]=role.id class="border-checkbox " [checked]="roleTypeState(role.id)" type="checkbox" [id]=role.id (change)="setRoleType($event)">
<label class="border-checkbox-label" >{{role.name}}</label>
        </div>

</ng-container>
<span *ngIf="roleNameHint">You must Choose role at least</span>

 <mat-hint *ngIf="roleNameHint"> {{'Admin.AdduserD.YoumustChooseroleatleast' | translate}}</mat-hint>
 </div>
 </div>
<div class="form-group">
    <button type="submit" (click)="registerUser()" class="btn btn-primary" [disabled]="password.invalid ||userName.invalid || lastName.invalid || firstName.invalid || !(roleName)" > {{'Admin.AdduserD.Submit' | translate}}</button>
</div>

<div *ngIf="errors" class="alert alert-danger" role="alert">
    <strong>Oops!</strong> {{errors}}
  </div>    -->

<!-- <div class="auth-wrapper">

  <div class="container-fluid ">
    <div class="row flex-row h-100">
      <div class=" col-md-12 p-0 d-md-block d-lg-block">
        <div class="bg2" style="background-image: url('assets/images/login-back.png')">
          <div class="overlay"></div>
          <app-lang></app-lang>
          <div class="col-xl-6 col-lg-6 col-md-9 my-auto">
            <div class="container-login">
              <div class="wrap-login">

                <form class="login-form" #f="ngForm" novalidate >
                  <a class="logo-centered d-flex align-items-center justify-content-center" [routerLink]="['/']" >
                    <img src="assets/images/logo-login.png" class="" alt="">
                    <div class="logo-text">
                      <p>  {{'form.university-hospital' | translate}}</p>
                      <p> {{'form.saudi-electronic' | translate}}</p>
                      </div>
                      </a>
                  <span class="login-form-title ">
                    {{'form.register' | translate}}
                  </span>


                    <span  *ngFor="let item of global.Messages" class="login-form-failed " >
                      {{item.body}}
                    </span>




                  <div class=" input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon10"><i class="ik ik-mail"></i></span>
                    </div>
                    <input class="form-control" id="email" type="email" #email="ngModel" [(ngModel)]="formData.email"
                      name="email" placeholder="{{'form.email' | translate}}"  pattern="^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$"  required>


                      <div style=" color: #f28d1e; font-size: 12px;display: block; " class="valid-feedback"
                      *ngIf="email.invalid && email.touched">
                      <span *ngIf="email.errors?.required">
                        {{'ValidationMessages.required'|translate}}
                      </span>
                      <span *ngIf="email.errors?.pattern">
                        {{'ValidationMessages.emailPattern'|translate}}
                      </span>
                    </div>

                  </div>

                  <div class=" input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon1"><i class="ik ik-user"></i></span>
                    </div>
                    <input class="form-control" id="userName" type="text" #userName="ngModel"
                      [(ngModel)]="formData.userName" required name="username"
                      placeholder="{{'form.user' | translate}}">



              <div style=" color: #f28d1e; font-size: 12px;display: block; " class="valid-feedback"
            *ngIf="userName.invalid && userName.touched">
            <span *ngIf="userName.errors?.required">
              {{'ValidationMessages.required'|translate}}
            </span>
            </div>
            </div>




                  <div class=" input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon20"><i class="ik ik-smartphone"></i></span>
                    </div>
                      <input class="form-control" id="phoneNumber" matInput type="tel" #phoneNumber="ngModel"
                        [(ngModel)]="formData.phoneNumber" name="phonenumber" placeholder="{{'employee.phone' | translate}}" required
                        pattern="^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$" minlength="10" maxlength="10">

                        <div style=" color: #f28d1e; font-size: 12px;display: block; " class="valid-feedback"
                        *ngIf="phoneNumber.invalid && phoneNumber.touched">
                        <span *ngIf="phoneNumber.errors?.required">
                          {{'ValidationMessages.required'|translate}}
                        </span>
                        <span *ngIf="phoneNumber.errors?.pattern">
                          {{'ValidationMessages.phonePattern'|translate}}
                        </span>
                        <span *ngIf="phoneNumber.errors?.minlength">
                          {{'ValidationMessages.equal10Numbers'|translate}}
                        </span>

                      </div>

                      </div>




                  <div class=" input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon1"><i class="ik ik-lock"></i></span>
                    </div>
                      <input class="form-control" id="password" matInput type="password" #password="ngModel"
                        [(ngModel)]="formData.password"   name=" password" placeholder="{{'form.password' | translate}}" minlength="8"  pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" required>


                        <div style=" color: #f28d1e; font-size: 12px;display: block; " class="valid-feedback"
                        *ngIf="password.invalid && password.touched">
                        <span *ngIf="password.errors?.required">
                          {{'ValidationMessages.required'|translate}}
                        </span>
                        <span *ngIf="password.errors?.pattern">
                          {{'ValidationMessages.passwordPattern'|translate}}
                        </span>

                      </div>

                      </div>

                  <div class="d-flex justify-content-between">

                    <button class="login-form-btn" (click)="registerUser()"  [disabled]="f.invalid || isRequesting" type="submit"
                   >
                      <i class="ik ik-corner-down-right"></i>
                      {{'form.register' | translate}}
                    </button>

                    <button class="login-form-btn" routerLink="/login">
                      <i class="ik ik-log-in"></i>
                      {{'form.login' | translate}}
                    </button>

                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
